export const ARCHITECTURE_ID = 7144
